import { render, staticRenderFns } from "./H35R.vue?vue&type=template&id=0e972f16&scoped=true"
import script from "./H35R.vue?vue&type=script&lang=js"
export * from "./H35R.vue?vue&type=script&lang=js"
import style0 from "./H35R.vue?vue&type=style&index=0&id=0e972f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e972f16",
  null
  
)

export default component.exports